export class ResumeForm {
    private id: string;
    private country: string;
    private policyNumber: string
    private email: string;
    private status: string;
    private token: string;

    getEmail(): string {
        return this.email;
    }

    setEmail(value: string) {
        this.email = value;
    }

    getId(): string {
        return this.id;
    }

    setId(value: string) {
        this.id = value;
    }

    getCountry(): string {
        return this.country;
    }

    setCountry(value: string) {
        this.country = value;
    }

    getPolicyNumber(): string {
        return this.policyNumber;
    }

    setPolicyNumber(value: string) {
        this.policyNumber = value;
    }

    getStatus(): string {
        return this.status;
    }

    setStatus(value: string) {
        this.status = value;
    }

    getToken(): string {
        return this.token;
    }

    setToken(value: string) {
        this.token = value;
    }
}